export const capitalizeFirstLetter = (word) => word.charAt(0).toUpperCase() + word.slice(1);

export const composeLetterFileName = (trackTitle, projectName, licensorName, licensorType, letterType) => [
    trackTitle.replaceAll('.', '_').replaceAll('/', '_'),
    projectName.replaceAll('.', '_').replaceAll('/', '_'),
    licensorName.replaceAll('.', '_').replaceAll('/', '_'),
    licensorType,
    letterType,
].filter((i) => i !== '').join(' - ');
